/* eslint-disable react/prop-types */

// @mui material components
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import moment from "moment";
// import NumberFormat from "react-number-format";

export const ProductDataRow = ({
  id,
  product_name: productName,
  categories: categoryName,
  status: productStatus,
  updated_at: updatedAt,
  onRowDelete,
  onRowEdit,
}) => ({
  product_name: (
    <MDBox display="flex" alignItems="center">
      <MDTypography display="block" variant="text" fontWeight="regular">
        {productName}
      </MDTypography>
    </MDBox>
  ),
  category_name: (
    <MDBox display="flex" alignItems="center">
      <MDTypography display="block" variant="text" fontWeight="regular">
        {categoryName.map((x) => x.category_name).join(", ")}
      </MDTypography>
    </MDBox>
  ),
  status: (
    <MDBox display="flex" alignItems="center">
      <MDTypography display="block" variant="text" fontWeight="regular">
        {productStatus}
      </MDTypography>
    </MDBox>
  ),
  updated_at: (
    <MDBox display="flex" alignItems="center">
      <MDTypography display="block" variant="text" fontWeight="regular">
        {moment(updatedAt).format("DD-MM-YYYY HH:mm:ss")}
      </MDTypography>
    </MDBox>
  ),
  action: (
    <MDBox>
      <MDButton
        iconOnly
        color="info"
        onClick={onRowEdit && (() => onRowEdit(id))}
        variant="outlined"
      >
        <Icon fontSize="small" component="i" color="info">
          edit
        </Icon>
      </MDButton>
      <MDButton
        iconOnly
        color="error"
        onClick={onRowDelete && (() => onRowDelete(id, productName))}
        variant="outlined"
      >
        <Icon fontSize="small" component="i" color="error">
          delete
        </Icon>
      </MDButton>
    </MDBox>
  ),
});

export default function data() {
  const Item = ({ name }) => (
    <MDBox display="flex" alignItems="center">
      <MDTypography display="block" variant="button" fontWeight="medium">
        {name}
      </MDTypography>
    </MDBox>
  );

  return {
    columns: [
      { Header: "Product Name", accessor: "product_name", align: "left", width: "20%" },
      {
        Header: "Category name",
        accessor: "category_name",
        align: "left",
        disableSortBy: true,
        width: "20%",
      },
      { Header: "Status", accessor: "status", align: "center", width: "20%" },
      { Header: "Updated At", accessor: "updated_at", align: "center", width: "20%" },
      { Header: "Action", accessor: "action", align: "center", disableSortBy: true, width: "20%" },
    ],

    rows: [
      {
        product_name: <Item name="product1" />,
        category_name: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Category1
          </MDTypography>
        ),
        status: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            active
          </MDTypography>
        ),
        updated_at: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            11-01-2022 13:37:50
          </MDTypography>
        ),
        action: (
          <MDBox>
            <MDButton iconOnly color="info" href="./product/product-edit" variant="outlined">
              <Icon fontSize="small" component="a" color="info">
                edit
              </Icon>
            </MDButton>
            <MDButton iconOnly color="error" href="./product/product-edit" variant="outlined">
              <Icon fontSize="small" component="a" color="error">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
      },
      {
        product_name: <Item name="product2" />,
        category_name: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Category2
          </MDTypography>
        ),
        status: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            active
          </MDTypography>
        ),
        updated_at: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            12-01-2022 09:11:03
          </MDTypography>
        ),
        action: (
          <MDBox>
            <MDButton iconOnly color="info" href="./product/product-edit" variant="outlined">
              <Icon fontSize="small" component="a" color="info">
                edit
              </Icon>
            </MDButton>
            <MDButton iconOnly color="error" href="./product/product-edit" variant="outlined">
              <Icon fontSize="small" component="a" color="error">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
      },
    ],
  };
}
